import { useEffect, memo } from 'react';
import styled from 'styled-components';

const DURATION_EFFECT = 2000;

const MainWrap = styled.div`
  width: 100vw;
  height: 100vh;
  background: transparent;
  position: absolute;
  color: white;
  font-size: 30px;
  padding: 30px;
  z-index: 9999;

  video,
  img {
    width: 100%;
    height: 100%;
  }
`;

const ConfettiVisualEffect = (props: {
  showConfetti: boolean;
  setShowConfetti: (v: boolean) => void;
}) => {
  const { showConfetti, setShowConfetti } = props;

  useEffect(() => {
    if (showConfetti) {
      window.setTimeout(() => {
        //play function or something
        setShowConfetti(false);
      }, DURATION_EFFECT);
    }
  }, [showConfetti]);

  return showConfetti ? (
    <MainWrap>
      {/*<img src="/experience/6k2.gif" alt="confetti" />*/}
      <img src="/experience/6SSp.gif" alt="confetti" />
      {/*<img src="/experience/confetti.png" alt="confetti" />*/}
    </MainWrap>
  ) : null;
};

export default memo(ConfettiVisualEffect);
